import axiosInstance from "@/api/axiosInstance";
import { FavoritesKeyResponse } from "./types";

export const getFavoritesKey = async (
  context?: "library" | "library-v2" | "podcasts" | "news" | "partner-network",
): Promise<FavoritesKeyResponse> => {
  const params = context ? { context } : undefined;
  const response = await axiosInstance.get<FavoritesKeyResponse>(
    "/api/search/favorites-key",
    { params },
  );
  return response.data;
};
